import Loadable from 'react-loadable';
import loadingComponent from '../components/loading';


export default (loader: any, loading = loadingComponent) => {
    return Loadable({
        loader,
        loading
    });
}